/**
 * useAuditoria — consulta a auditoria append-only (RF-ADM-02, RN-GLOBAL-003).
 * React Query sobre o `auditoriaApi` (rota admin do M1).
 */

import { useQuery } from '@tanstack/react-query';
import { useServices } from '../contexts/ServicesContext';
import { AuditoriaFiltro, ListaAuditoria } from '../services/auditoriaApi';

export function useAuditoria(filtro: AuditoriaFiltro = {}): {
  data: ListaAuditoria | undefined;
  isLoading: boolean;
  isError: boolean;
} {
  const { auditoria } = useServices();
  const query = useQuery({
    queryKey: ['auditoria', filtro],
    queryFn: () => auditoria.listar(filtro),
  });
  return { data: query.data, isLoading: query.isLoading, isError: query.isError };
}
